import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CheckBlock } from '../../../dmo/check-block';

@Component({
  selector: 'ls-check-block-container',
  templateUrl: './check-block-container.component.html',
  styleUrls: ['./check-block-container.component.scss']
})
export class CheckBlockContainerComponent {
  @Input()
  public checkBlocks: Array<CheckBlock>;
  @Output()
  public checkBlocksChange: EventEmitter<Array<CheckBlock>> = new EventEmitter<
    Array<CheckBlock>
  >();

  public blockChanged(): void {
    this.checkBlocksChange.emit(this.checkBlocks);
  }
}
